module.exports = __webpack_public_path__ + "img/00047.6cc36cd3.webp";